var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"blackedout presentation_iframe",attrs:{"fluid":""}},[_c('div',{staticClass:"loadingdiv"},[_c('h2',[_vm._v("Loading...")])]),_c('iframe',{attrs:{"id":"presentationIframe","src":_vm.source,"allowfullscreen":"","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }